if (!customElements.get('giveaway-countdown')) {
  class GiveawayCountdown extends HTMLElement {
    connectedCallback() {
      this.startAt = Date.parse(this.dataset.start || '');
      this.endAt = Date.parse(this.dataset.end || '');
      this.label = this.querySelector('[data-countdown-label]');
      this.grid = this.querySelector('[data-countdown-grid]');
      this.expired = this.querySelector('[data-countdown-expired]');
      this.values = {
        days: this.querySelector('[data-countdown-days]'),
        hours: this.querySelector('[data-countdown-hours]'),
        minutes: this.querySelector('[data-countdown-minutes]'),
        seconds: this.querySelector('[data-countdown-seconds]'),
      };

      if (Number.isNaN(this.endAt)) {
        this.dataset.state = 'invalid';
        if (this.label) this.label.textContent = 'Add a valid giveaway deadline in the theme editor';
        return;
      }

      this.render();
      if (this.dataset.state !== 'expired') {
        this.interval = window.setInterval(() => this.render(), 1000);
      }
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }

    render() {
      const now = Date.now();
      let state = 'active';
      let target = this.endAt;
      let label = this.dataset.activeLabel;

      if (!Number.isNaN(this.startAt) && now < this.startAt) {
        state = 'upcoming';
        target = this.startAt;
        label = this.dataset.prelaunchLabel;
      } else if (now >= this.endAt) {
        state = 'expired';
      }

      this.dataset.state = state;
      this.syncActiveElements(state !== 'expired');

      if (state === 'expired') {
        this.setValue('days', 0);
        this.setValue('hours', 0);
        this.setValue('minutes', 0);
        this.setValue('seconds', 0);
        if (this.grid) this.grid.hidden = true;
        if (this.label) this.label.hidden = true;
        if (this.expired) {
          this.expired.hidden = false;
          this.expired.textContent = this.dataset.expiredLabel;
        }
        window.clearInterval(this.interval);
        return;
      }

      if (this.grid) this.grid.hidden = false;
      if (this.label) {
        this.label.hidden = false;
        this.label.textContent = label;
      }
      if (this.expired) this.expired.hidden = true;

      const distance = Math.max(0, target - now);
      const totalSeconds = Math.floor(distance / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.setValue('days', days);
      this.setValue('hours', hours);
      this.setValue('minutes', minutes);
      this.setValue('seconds', seconds);

      if (this.grid) {
        this.grid.setAttribute(
          'aria-label',
          `${label}: ${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`,
        );
      }
    }

    setValue(unit, value) {
      if (this.values[unit]) this.values[unit].textContent = String(value).padStart(2, '0');
    }

    syncActiveElements(isActive) {
      const scope = this.closest('[data-giveaway-scope]') || this.closest('.shopify-section');
      if (!scope) return;
      scope.querySelectorAll('[data-giveaway-active-only]').forEach((element) => {
        element.hidden = !isActive;
      });
    }
  }

  customElements.define('giveaway-countdown', GiveawayCountdown);
}
